module.exports = __webpack_public_path__ + "static/media/battery.6745864a.svg";